<template>
    <div id="app">
        <toast-view />
        <div class="twi-content-container w3-cell-row">
            <div v-show="sessionActive" class="twi-navigation-container w3-cell w3-mobile">
                <h2>{{ $t('Dynamic DNS Manager') }}</h2>

                <router-link :class="['twi-navigation-link', {'twi-navigation-link-active': $route.path === '/'}]" to="/">Dashboard</router-link>
                <router-link :class="['twi-navigation-link', {'twi-navigation-link-active': $route.path === '/tokens'}]" to="/tokens">Tokens</router-link>
                <router-link :class="['twi-navigation-link', {'twi-navigation-link-active': $route.path === '/domains'}]" to="/domains">Domains</router-link>
                <a class="twi-navigation-link logout" @click="performLogout()">{{ $t('Logout') }}</a>
            </div>

            <div class="twi-page-container w3-cell w3-mobile">
                <div v-show="sessionActive" class="twi-top-bar">
                    <span v-if="sessionActive">{{ $t('Welcome') }}, <strong>{{ session.getUser().contactName }}</strong></span>
                </div>
                <div class="twi-page-content">
                    <router-view />
                </div>
            </div>
        </div>

        <div class="twi-footer w3-center">
            <p>
                <router-link to="/">{{ $t('Start') }}</router-link> | 
                <router-link to="/imprint">{{ $t('Imprint') }}</router-link> |
                <router-link to="/privacy">{{ $t('Privacy policy') }}</router-link><br>
                Copyright &copy; 2020{{ currentYear > 2020 ? `-${currentYear}` : '' }} top-web.info, All Rights Reserved.
            </p>
            <p>
                {{ $t('Application version') }}: {{ appVersion }} | {{ $t('API version') }}: {{ apiVersion }}
            </p>
        </div>
    </div>
</template>

<style scoped>
.twi-navigation-link.logout {
    color: #990000;
}
</style>

<script>
import moment from 'moment'

import Api from 'Api'
import Store from '@/utils/Store'
import EventBus from '@/utils/EventBus'

import ToastView from '@/components/ToastView'
import Session from './model/Session'

export default {

    components: {
        ToastView
    },

    data () {
        return {
            appVersion: process.env.VUE_APP_VERSION,
            apiVersion: 'N/A',
            currentYear: moment().year()
        }
    },

    computed: {
        sessionActive: () => Store.state.session instanceof Session,
        session: () => Store.state.session
    },
    
    created () {
        let self = this
        window.toast = function (data) {
            EventBus.$emit('toast', data)
        }

        Api.getRootVersion()
            .then(resp => {
                self.apiVersion = resp.data
            })
            .catch(() => {
                window.toast({ text: 'Failed to query API version.', color: 'red' })
            })

        if (!self.sessionActive) {
            try {
                Store.commit('session', Session.restore())
            } catch (err) {
                if (self.$router.currentRoute.path !== '/login') {
                    self.$router.push('/login')
                }
            }
        }
    },

    destroyed () {
        window.toast = null
    },

    methods: {
        performLogout () {
            let self = this

            Api.getAuthLogout()
                .then(() => {
                    Store.commit('session', null)
                    Session.purge()
                    self.$router.push('/login')
                })
        }
    }

}
</script>

<i18n src="@/lang/common.json"></i18n>
<i18n src="@/lang/app.json"></i18n>
